<template lang="pug">
div
  el-card.card-vtn(:body-style="{ width: '100%' }" shadow="hover", v-if="!processo.vtn || !processo.vtn.isFinalizado")
    div
      p(v-if="!processo.vtn || !processo.vtn.id") Ainda não existe um VTN para este processo.
    .row-calcular
      p {{ processo.vtn && processo.vtn.id ? 'Continue' : 'Realize' }} o cálculo do VTN.
      el-button(
        type="success"
        @click="$router.push({ name: 'cof/vtn', params: { numeroProcesso: processo.numero }})"
      )
        i.fas.fa-credit-card
        span.center &nbsp Calcular VTN
  card-financeiro(
    :cardTitle="isEstadoMA ? 'Gerenciar Boleto(s)' : 'Gerenciar DAEs'",
    :showBtnAction="true",
    btnActionTitle="Cadastrar"
    btnIconClass="fas fa-plus"
    @execAction="cadastroDae"
  )
    template(slot="body")
      el-table.table(:data="daes")
        template(slot="empty") Não há registros.
        el-table-column(
          prop='receita'
          label='Tipo',
          width="auto"
        )
        el-table-column(
          prop='dataVencimento'
          label='Vencimento',
          width="auto"
        )
        el-table-column(
          prop='status'
          label='Situação',
          width="auto"
        )
        el-table-column(
          prop='parcela'
          label='Parcela',
          width="auto"
        )
        el-table-column(
          label='Valor',
          width="auto"
        )
          template(slot-scope="scope")
            span R$ {{ scope.row.isQuitada ? scope.row.valorPago : scope.row.valorAjustado | formatDouble }}
        el-table-column(
          :label="isEstadoMA ? 'Boleto' : 'DAE'",
          width='100',
          align="center"
        )
          template(slot-scope='scope')
            span.download-dae(@click="baixarDae(scope.row)")
              i.icon

      app-paginacao(
        :total="totalDaes"
        :pagina="pagina",
        @changePage="changePage",
        :tamanhoPagina="15"
      )

  el-button.margin-2-por-cento(
    type="default"
    @click="voltar"
  )
    span.center
      i.fas.fa-chevron-left
      b &nbsp Voltar
</template>

<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppPaginacao from '@/components/AppPaginacao'
import CardFinanceiro from '../components/CardFinanceiro'

export default {
  components: {
    AppNotificacao,
    AppPaginacao,
    CardFinanceiro
  },

  data () {
    return {
      processo: {
        numero: null,
        vtn: null
      },
      daes: [],
      totalDaes: 0,
      showPdf: true,
      filtro: {
        origemDocumento: '',
        pagina: 0,
        tamanhoPagina: 15
      }
    }
  },

  computed: {

    pagina () {
      return this.filtro.pagina + 1
    },
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    }

  },

  async created () {
    if (!this.$route.params.numeroProcesso) {
      this.$router.push({ name: 'cof/home' })
      return
    }

    this.processo = await this.findProcessoByNumeroProcesso(this.$route.params.numeroProcesso)

    this.findDaes()
  },

  methods: {
    ...mapActions({
      findProcessoByNumeroProcesso: 'cadastroProcessoFisico/findProcessoByNumeroProcesso',
      findDaesByNumeroProcesso: 'dae/findDaesByNumeroProcesso',
      downloadDae: 'dae/downloadDae'
    }),

    voltar () {
      this.$router.push({
        name: 'cof/home'
      })
    },

    cadastroDae () {
      this.$router.push({
        name: 'dae/cadastroDae',
        params: {
          numeroProcesso: this.processo.numero
        }
      })
    },

    async baixarDae (receita) {
      await this.downloadDae(receita.id)
      this.findDaes()
    },

    async findDaes () {
      this.filtro.origemDocumento = this.$route.params.numeroProcesso
      const result = await this.findDaesByNumeroProcesso(this.filtro)
      this.daes = result.content
      this.totalDaes = result.totalElements
    },

    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.findDaes()
    }
  }
}
</script>

<style lang="scss" scoped>

.icon::before {
  font-family: "Font Awesome 5 Pro", sans-serif;
  font-style: normal;
  font-size: 16px;
  content: "\f1c1";
  font-weight: normal;
}

.download-dae {
  cursor: pointer;
  &:hover {
    .icon::before {
      content: "\f019";
      font-weight: 900;
    }
    font-size: 25px;
    color: #009f61
  }
}

.card-info {
  border-radius: 15px;
  background-color: #eaeef1;
  border-color: #c8cccf;
  margin: 2%;
}

.card-vtn {
  border-radius: 15px;
  background-color: white;
  border-color: #009f61;
  color: #b8ebc0;
  margin: 2%;
}

#appArrecadacao .card-vtn p {
  color: #018351;
}

// .listagem-daes {
//   border-radius: 15px;
//   margin: 2%;
// }

// .card-header {
//   display: flex;
//   justify-content: space-between;
//   align-items: flex-start;
// }

.row-calcular {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.margin-2-por-cento {
  margin: 2%;
}

.margin-top-20 {
  margin-top: 20px;
}

h1 {
  margin: 0px;
}

</style>



// WEBPACK FOOTER //
// src/screens/financeiro/processoFisico/ListagemDaes.vue